import { connect } from 'react-redux';
import { AnnotationBorderStyleType } from 'Shared/3P/pdf';
import Notifications from 'Shared/Notifications/notifications';

const mapStateToProps = (state: any) => ({
   notifications: state.headerState.notifications,
});

function withNotifications(DisplayComponent: any) {
   const ComponentWithNotificationService = ({ notifications, ...passThrough }: any) => (
      <DisplayComponent notifications={notifications} {...passThrough} />
   );

   return connect(mapStateToProps)(ComponentWithNotificationService);
}

export default withNotifications;
